/* !!! This file is auto-generated. Please edit the source files instead */
(() => {
  var __defProp = Object.defineProperty;
  var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/js/pmed-flow/pmed-components/pmed-form.js
  var _PmedForm = class _PmedForm extends HTMLElement {
    constructor() {
      super();
      this.submitButton = this.querySelector("pmed-submit-button");
      this.form = this.querySelector("form");
      this.questions = Array.from(this.querySelectorAll(".pmed-question"));
      this.modal = this.closest(".pmed-modal");
      this.handleSubmit = this.handleSubmit.bind(this);
    }
    connectedCallback() {
      this.form.addEventListener("submit", this.handleSubmit);
    }
    disconnectedCallback() {
      this.form.removeEventListener("submit", this.handleSubmit);
    }
    get formId() {
      return this.getAttribute("data-form-id");
    }
    validateForm() {
      this.questions.forEach((question) => {
        question.validate();
      });
      const firstError = this.querySelector(".has-error");
      if (firstError) {
        firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        firstError.focus({ preventScroll: true });
        return false;
      }
      return true;
    }
    handleSubmit(event) {
      return __async(this, null, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        event.preventDefault();
        if (!this.validateForm()) {
          return;
        }
        this.submitButton.startLoading();
        const endpoint = "https://api.airtable.com/v0/appBmXgsaMjMMf4er/tblEhvpPA1j9I2xaX";
        const apiKey = "pathzdzLRk7mYJmqn.9da3698400056aeac34c27e8bc18afceed3e3801dcf50c62bd87d10d3f5feb66";
        if (!endpoint || !apiKey) {
          (_b = (_a = this.submitButton).stopLoading) == null ? void 0 : _b.call(_a);
          return (_c = this.showError) == null ? void 0 : _c.call(this, "Missing Airtable endpoint or API key");
        }
        const submissionId = window.crypto && crypto.randomUUID ? crypto.randomUUID() : ("10000000-1000-4000-8000" + -1e11).replace(
          /[018]/g,
          (c) => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
        const toYesNo = /* @__PURE__ */ __name((v) => String(v).toLowerCase() === "yes" ? "Yes" : "No", "toYesNo");
        const getSort = /* @__PURE__ */ __name((el, fallback) => {
          var _a2, _b2;
          return Number(((_a2 = el == null ? void 0 : el.dataset) == null ? void 0 : _a2.sort) || ((_b2 = el == null ? void 0 : el.dataset) == null ? void 0 : _b2.sortOrder) || fallback);
        }, "getSort");
        const getQuestionLabel = /* @__PURE__ */ __name((qEl) => {
          var _a2, _b2, _c2;
          return ((_a2 = qEl.dataset.questionLabel) == null ? void 0 : _a2.trim()) || ((_c2 = (_b2 = qEl.querySelector(".pmed-question__label")) == null ? void 0 : _b2.textContent) == null ? void 0 : _c2.trim()) || "";
        }, "getQuestionLabel");
        const getOptionLabel = /* @__PURE__ */ __name((qEl, inputEl) => {
          var _a2;
          let txt = (_a2 = inputEl.value) == null ? void 0 : _a2.trim();
          if (txt) return txt;
          const associated = qEl.querySelector(`label[for="${inputEl.id}"]`);
          return ((associated == null ? void 0 : associated.textContent) || inputEl.getAttribute("aria-label") || "").trim();
        }, "getOptionLabel");
        const buildRecords = /* @__PURE__ */ __name(() => {
          const records = [];
          this.questions.forEach((qEl, idx) => {
            const questionText = getQuestionLabel(qEl);
            const qSort = getSort(qEl, idx + 1);
            const radios = qEl.querySelectorAll('input[type="radio"]');
            const checkboxes = qEl.querySelectorAll('input[type="checkbox"]');
            if (radios.length) {
              const checked = qEl.querySelector('input[type="radio"]:checked');
              if (!checked) return;
              const rSort = getSort(checked, qSort);
              records.push({
                fields: {
                  SubmissionID: submissionId,
                  Question: questionText,
                  Answer: toYesNo(checked.value),
                  // normalize "yes"/"no" -> "Yes"/"No"
                  SortOrder: rSort
                }
              });
            } else if (checkboxes.length) {
              const checkedOnes = Array.from(checkboxes).filter((cb) => cb.checked);
              if (checkboxes.length > 1) {
                if (!checkedOnes.length) return;
                records.push({
                  fields: {
                    SubmissionID: submissionId,
                    Question: questionText,
                    SortOrder: qSort
                  }
                });
                checkedOnes.forEach((cb, i) => {
                  const optionLabel = getOptionLabel(qEl, cb) || questionText;
                  const optionSort = getSort(cb, qSort + i + 1);
                  records.push({
                    fields: {
                      SubmissionID: submissionId,
                      Question: optionLabel,
                      Answer: "Yes",
                      SortOrder: optionSort
                    }
                  });
                });
              } else {
                const onlyCb = checkboxes[0];
                if (!onlyCb) return;
                if (onlyCb.checked) {
                  const optionLabel = getOptionLabel(qEl, onlyCb) || questionText;
                  const cSort = getSort(onlyCb, qSort);
                  records.push({
                    fields: {
                      SubmissionID: submissionId,
                      Question: optionLabel,
                      Answer: "Yes",
                      SortOrder: cSort
                    }
                  });
                }
              }
            }
          });
          return records;
        }, "buildRecords");
        const chunk = /* @__PURE__ */ __name((arr, size = 10) => Array.from({ length: Math.ceil(arr.length / size) }, (_, i) => arr.slice(i * size, i * size + size)), "chunk");
        const postBatches = /* @__PURE__ */ __name((allRecords) => __async(this, null, function* () {
          var _a2;
          const batches = chunk(allRecords, 10);
          try {
            for (const [i, batch] of batches.entries()) {
              const res = yield fetch(endpoint, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${apiKey}`,
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({ records: batch })
              });
              const data = yield res.json().catch(() => ({}));
              if (!res.ok) {
                const errText = ((_a2 = data == null ? void 0 : data.error) == null ? void 0 : _a2.message) || res.statusText;
                console.error(`Airtable batch ${i + 1} failed:`, errText);
                return false;
              }
            }
            return true;
          } catch (err) {
            return false;
          }
        }), "postBatches");
        try {
          const records = buildRecords();
          if (!records.length) {
            throw new Error("No responses to submit.");
          }
          const success = yield postBatches(records);
          if (success) {
            this.addToCart(submissionId);
          } else {
            (_d = this.showError) == null ? void 0 : _d.call(this, "Form submission failed. Please try again.");
            (_f = (_e = this.submitButton).stopLoading) == null ? void 0 : _f.call(_e);
          }
        } catch (err) {
          console.error(err);
          (_g = this.showError) == null ? void 0 : _g.call(this, "There was a problem submitting the form. Please try again later.");
          (_i = (_h = this.submitButton).stopLoading) == null ? void 0 : _i.call(_h);
        }
      });
    }
    addToCart(submissionId) {
      var _a, _b;
      const productFormEl = document.querySelector(".product-info product-form");
      const productInnerForm = productFormEl == null ? void 0 : productFormEl.querySelector(".js-product-form");
      if (!productFormEl || !productInnerForm) {
        (_b = (_a = this.submitButton).stopLoading) == null ? void 0 : _b.call(_a);
        console.warn("product-form or its .js-product-form not found");
        return;
      }
      let submissionInput = productInnerForm.querySelector('input[name="properties[submission_id]"]');
      if (!submissionInput) {
        submissionInput = document.createElement("input");
        submissionInput.type = "hidden";
        submissionInput.name = "properties[submission_id]";
        productInnerForm.appendChild(submissionInput);
      }
      submissionInput.value = submissionId;
      const onSuccess = /* @__PURE__ */ __name(() => {
        var _a2, _b2, _c;
        cleanup();
        (_b2 = (_a2 = this.submitButton).stopLoading) == null ? void 0 : _b2.call(_a2);
        (_c = this.closePopup) == null ? void 0 : _c.call(this);
      }, "onSuccess");
      const onError = /* @__PURE__ */ __name((e) => {
        var _a2, _b2, _c, _d;
        cleanup();
        (_b2 = (_a2 = this.submitButton).stopLoading) == null ? void 0 : _b2.call(_a2);
        const msg = ((_c = e == null ? void 0 : e.detail) == null ? void 0 : _c.error) || "There was a problem adding to cart.";
        (_d = this.showError) == null ? void 0 : _d.call(this, msg);
      }, "onError");
      const onAdd = /* @__PURE__ */ __name(() => onSuccess(), "onAdd");
      const onChange = /* @__PURE__ */ __name(() => onSuccess(), "onChange");
      const cleanup = /* @__PURE__ */ __name(() => {
        productFormEl.removeEventListener("on:cart:add", onAdd);
        productFormEl.removeEventListener("on:line-item:change", onChange);
        productFormEl.removeEventListener("on:cart:error", onError);
        document.removeEventListener("on:cart:add", onAdd, true);
        document.removeEventListener("on:line-item:change", onChange, true);
        document.removeEventListener("on:cart:error", onError, true);
      }, "cleanup");
      productFormEl.addEventListener("on:cart:add", onAdd, { once: true });
      productFormEl.addEventListener("on:line-item:change", onChange, { once: true });
      productFormEl.addEventListener("on:cart:error", onError, { once: true });
      document.addEventListener("on:cart:add", onAdd, { once: true, capture: true });
      document.addEventListener("on:line-item:change", onChange, { once: true, capture: true });
      document.addEventListener("on:cart:error", onError, { once: true, capture: true });
      if (productInnerForm.requestSubmit) {
        productInnerForm.requestSubmit();
      } else {
        productInnerForm.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      }
    }
    closePopup() {
      this.modal.close();
    }
    showError(message) {
      var _a;
      const msg = message || "Database error. Please try again later.";
      (_a = this.submitButton) == null ? void 0 : _a.showError(msg);
      console.error(msg);
    }
  };
  __name(_PmedForm, "PmedForm");
  var PmedForm = _PmedForm;
  var pmed_form_default = PmedForm;

  // src/js/pmed-flow/pmed-components/pmed-question-radios.js
  var _PmedQuestionRadios = class _PmedQuestionRadios extends HTMLElement {
    constructor() {
      super();
      this.radios = this.querySelectorAll("input[type=radio]");
      this.errorMessage = this.querySelector(".pmed-question__error-message");
      this.handleRadioChange = this.handleRadioChange.bind(this);
    }
    connectedCallback() {
      this.radios.forEach((radioEl) => {
        radioEl.addEventListener("change", this.handleRadioChange);
      });
    }
    handleRadioChange() {
      this.validate();
    }
    validate() {
      const isEmpty = !Array.from(this.radios).some((radio) => radio.checked);
      if (isEmpty) {
        this.errorMessage.classList.remove("hidden");
        this.classList.add("has-error");
      } else {
        this.errorMessage.classList.add("hidden");
        this.classList.remove("has-error");
      }
    }
  };
  __name(_PmedQuestionRadios, "PmedQuestionRadios");
  var PmedQuestionRadios = _PmedQuestionRadios;
  var pmed_question_radios_default = PmedQuestionRadios;

  // src/js/pmed-flow/pmed-components/pmed-question-checkboxes.js
  var _PmedQuestionCheckboxes = class _PmedQuestionCheckboxes extends HTMLElement {
    constructor() {
      super();
      this.checkboxes = this.querySelectorAll("input[type=checkbox]");
      this.errorMessage = this.querySelector(".pmed-question__error-message");
      this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }
    connectedCallback() {
      this.checkboxes.forEach((radioEl) => {
        radioEl.addEventListener("change", this.handleCheckboxChange);
      });
    }
    handleCheckboxChange(event) {
      this.validate();
      this.handleNoneOfAbove(event);
    }
    validate() {
      const isEmpty = !Array.from(this.checkboxes).some((radio) => radio.checked);
      if (isEmpty) {
        this.errorMessage.classList.remove("hidden");
        this.classList.add("has-error");
      } else {
        this.errorMessage.classList.add("hidden");
        this.classList.remove("has-error");
      }
    }
    handleNoneOfAbove(event) {
      const target = event.target;
      const isNoneOfAbove = target.value.toLowerCase() === "none";
      if (isNoneOfAbove) {
        if (target.checked) {
          this.checkboxes.forEach((checkbox) => {
            if (checkbox !== target) checkbox.checked = false;
          });
        }
      } else {
        this.checkboxes.forEach((checkbox) => {
          if (String(checkbox.value).toLowerCase() === "none") {
            checkbox.checked = false;
          }
        });
      }
    }
  };
  __name(_PmedQuestionCheckboxes, "PmedQuestionCheckboxes");
  var PmedQuestionCheckboxes = _PmedQuestionCheckboxes;
  var pmed_question_checkboxes_default = PmedQuestionCheckboxes;

  // src/js/pmed-flow/pmed-components/pmed-submit-button.js
  var _PmedSubmitButton = class _PmedSubmitButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector("button");
      this.loadingInfo = this.querySelector(".pmed-form__submit-info-message-wrapper");
      this.errorWrapper = this.querySelector(".pmed-form__submit-error-message-wrapper");
      this.errorMessage = this.querySelector(".pmed-form__submit-error-message-content");
      this.loadingInterval = null;
    }
    connectedCallback() {
      if (this.button) {
        this.button.disabled = false;
      }
    }
    startLoading() {
      if (!this.button) return;
      this.button.disabled = true;
      this.button.classList.add("pmed-button--loading");
      this.loadingInfo.classList.remove("hidden");
      let dots = 0;
      this.button.textContent = "Submitting";
      clearInterval(this.loadingInterval);
      this.loadingInterval = setInterval(() => {
        dots = (dots + 1) % 4;
        this.button.textContent = "Submitting" + ".".repeat(dots);
      }, 500);
    }
    stopLoading() {
      if (!this.button) return;
      this.button.classList.remove("pmed-button--loading");
      this.loadingInfo.classList.add("hidden");
      clearInterval(this.loadingInterval);
      this.loadingInterval = null;
      this.button.disabled = false;
      this.button.textContent = "Submit";
    }
    disabled() {
      if (this.button) {
        this.button.disabled = true;
      }
    }
    enabled() {
      if (this.button) {
        this.button.disabled = false;
      }
    }
    showError(message) {
      this.stopLoading();
      this.errorWrapper.classList.remove("hidden");
      this.errorMessage.textContent = String(message);
    }
  };
  __name(_PmedSubmitButton, "PmedSubmitButton");
  var PmedSubmitButton = _PmedSubmitButton;
  var pmed_submit_button_default = PmedSubmitButton;

  // src/js/pmed-main.js
  var pmedFlow = /* @__PURE__ */ function() {
    function initPMED() {
      const atcButton = document.querySelector(".pmed-atc-button");
      if (!atcButton) {
        console.warn('"product-form .pmed-atc-button" not found');
        return;
      }
      atcButton.addEventListener("click", handleATCButtonClick);
      customElements.define("pmed-form", pmed_form_default);
      customElements.define("pmed-question-radios", pmed_question_radios_default);
      customElements.define("pmed-question-checkboxes", pmed_question_checkboxes_default);
      customElements.define("pmed-submit-button", pmed_submit_button_default);
    }
    __name(initPMED, "initPMED");
    function handleATCButtonClick() {
      const pmedModal = document.querySelector(".pmed-modal");
      pmedModal.open();
    }
    __name(handleATCButtonClick, "handleATCButtonClick");
    function isPmedProductPage() {
      return window.location.href.includes("products") && document.querySelector(".pmed-modal");
    }
    __name(isPmedProductPage, "isPmedProductPage");
    return {
      initPMED,
      isPmedProductPage
    };
  }();
  if (pmedFlow.isPmedProductPage()) {
    pmedFlow.initPMED();
  }
})();
